module.exports = __webpack_public_path__ + "img/37.dee65a79.png";